import { getNames } from 'src/utils/common';

export default values => ({
  name: values && values.fullName ? getNames(values.fullName) : '',
  paternalName: values?.fullName?.split(' ').slice(-2, -1)[0] ?? '',
  maternalName: values?.fullName?.split(' ').slice(-1)[0] ?? '',
  kinship: values?.kinship ?? '',
  curp: values?.curp ?? '',
  rfc: values?.rfc ?? '',
  identificationNumber: values?.identificationNumber ?? '',
  sex: values?.sex ?? '',
  nationality: values?.nationality ?? ''
});
